import { Box, Link, Spinner, Text } from '@nimbus-ds/components';
import { UseVariantsRangeResult } from 'domains/Catalog/Inventory/pages/hooks';

import './ShowHideVariantsLink.scss';

type ShowHideVariantsLinkProps = Omit<UseVariantsRangeResult, 'variants'>;

function ShowHideVariantsLink({
  link,
  spinner,
}: Readonly<ShowHideVariantsLinkProps>) {
  const handleClickLink = () => {
    link.handleClick();
  };

  if (!link.show && !spinner.show) {
    return null;
  }

  return (
    <div className="stratus--show-hide-variants-link">
      <div className="container">
        {link.show && (
          <Link
            appearance="primary"
            as="button"
            onClick={handleClickLink}
            textDecoration="none"
          >
            {link.text}
          </Link>
        )}
        {spinner.show && (
          <Box display="flex" flexDirection="row" gap="2">
            <Spinner size="small" />
            <Text>{spinner.text}</Text>
          </Box>
        )}
      </div>
    </div>
  );
}

export default ShowHideVariantsLink;
